'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function IconCloseTiny(props) {
    return (React__namespace.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 12 12", width: "1em", height: "1em" }, props),
        React__namespace.createElement("defs", null,
            React__namespace.createElement("path", { id: "prefix__close-tiny", d: "M7.426 6.001l4.278-4.279A1.008 1.008 0 1010.278.296L6 4.574 1.723.296A1.008 1.008 0 10.295 1.722l4.278 4.28-4.279 4.277a1.008 1.008 0 101.427 1.426L6 7.427l4.278 4.278a1.006 1.006 0 001.426 0 1.008 1.008 0 000-1.426L7.425 6.001z" })),
        React__namespace.createElement("use", { fillRule: "evenodd", xlinkHref: "#prefix__close-tiny" })));
}

module.exports = IconCloseTiny;
